"use client";

import styled, { keyframes, css } from "styled-components";

const progressAnimation = keyframes`
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 100% 0%;
  }
`;

export const ProgressContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProgressLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 4px;
`;

export const BoxProgressBar = styled.div<{
  $height?: string;
  $backgroundColor?: string;
}>`
  width: 100%;
  height: ${(props) => props.$height || "13px"};
  background-color: ${(props) =>
    props.$backgroundColor || "var(--primarySystem100)"};
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const ProgressFill = styled.div<{
  $width: number;
  $color?: string;
  $animated?: boolean;
  $striped?: boolean;
}>`
  width: ${(props) => props.$width}%;
  height: 100%;
  background-color: ${(props) => props.$color || "var(--primary)"};
  transition: width 0.3s ease-in-out;
  border-radius: inherit;
  position: relative;

  ${(props) =>
    props.$striped &&
    css`
      background-image: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.15) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 255, 255, 0.15) 75%,
        transparent 75%,
        transparent
      );
      background-size: 20px 20px;
    `}

  ${(props) =>
    props.$animated &&
    css`
      animation: ${progressAnimation} 1s linear infinite;
    `} // &::after {
  //   content: '';
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   background: linear-gradient(
  //     to right,
  //     transparent,
  //     rgba(255, 255, 255, 0.3),
  //     transparent
  //   );
  //   border-radius: inherit;
  // }
`;

export const ProgressText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 600;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  z-index: 1;
`;
